import analytics from '@utils/analytics';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProductBoutiqueModal from './ProductBoutiqueModal';
const ProductActionReserveInBoutique = (props) => {
    const { t } = useTranslation();
    const [showOverlay, setShowOverlay] = useState(false);
    const buttonRef = useRef(null);
    const [scrollTop, setScrollTop] = useState(0);
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { type: "button", className: "button button--link button--arrow-right", "aria-haspopup": "dialog", ref: buttonRef, onClick: () => {
                var _a, _b;
                setScrollTop(document.documentElement.scrollTop);
                setShowOverlay(true);
                document.documentElement.classList.add('no-overflow-ios');
                analytics.reserveInBoutique(((_a = props.product) === null || _a === void 0 ? void 0 : _a.id) || ((_b = props.product) === null || _b === void 0 ? void 0 : _b.masterId));
            } },
            React.createElement("span", null, t('product.reserveinboutique'))),
        props.product && (React.createElement(ProductBoutiqueModal, { isOpen: showOverlay, title: t('product.reserveinboutique'), mode: "reserve", product: props.product, size: props.size, color: props.color, colourVariations: props.colourVariations, sizeVariations: props.sizeVariations, onRequestClose: () => {
                document.documentElement.classList.remove('no-overflow-ios');
                document.documentElement.scrollTop = scrollTop;
                setShowOverlay(false);
                buttonRef.current.focus();
            } }))));
};
export default ProductActionReserveInBoutique;
